import { Trans, useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { Text, useWizardContext } from '@lounge-fe/ui-kit'
import { StepLayoutProps } from '../types'

export const StepLayout = ({
  children,
  title,
  subtitle,
  showProgress = true,
}: StepLayoutProps) => {
  const { t } = useTranslation()
  const { activeStep, totalSteps } = useWizardContext()
  return (
    <motion.div
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      {showProgress && (
        <div
          className="flex justify-between"
          data-testid="step-layout-progress"
        >
          <Text>{t('fitting_room.your_current_fit')}</Text>
          <Text>
            {t('general.x_of_y', { x: activeStep, y: totalSteps - 3 })}
          </Text>
        </div>
      )}
      <div className="mb-6">
        <Text as="h2" variant="title-four" className="mb-2">
          {title}
        </Text>
        <Trans>
          {typeof subtitle === 'string' ? <Text>{subtitle}</Text> : subtitle}
        </Trans>
      </div>
      {children}
    </motion.div>
  )
}
